import React from 'react';

const PhpSecurityAdvisory = ({ headingLevel = 'h2', compact = false }) => {
  const Heading = headingLevel;

  return (
    <aside className={`advisory-panel ${compact ? 'advisory-panel-compact' : ''}`} aria-labelledby={compact ? 'php-advisory-heading-home' : 'php-advisory-heading'}>
      <p className="text-xs font-bold uppercase tracking-[0.16em] text-amber-dark">Information — October 2026</p>
      <Heading id={compact ? 'php-advisory-heading-home' : 'php-advisory-heading'} className={`mt-3 font-semibold tracking-[-0.03em] text-ink ${compact ? 'text-lg' : 'text-2xl'}`}>
        Recent PHP security update — October 2026
      </Heading>
      <p className={`mt-3 leading-7 text-ink/70 ${compact ? 'text-sm' : 'text-base'}`}>
        In October 2026, UK cyber security authorities highlighted critical vulnerabilities affecting PHP, a technology used by many websites. Website owners should check whether their systems are affected and whether the necessary updates have been applied.
      </p>
      <p className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-sm font-semibold">
        <a href="https://www.ncsc.gov.uk/news/critical-security-issue-affecting-php" target="_blank" rel="noreferrer" className="text-violet-dark hover:text-magenta">
          NCSC notice
        </a>
        <a href="https://www.cert.europa.eu/publications/security-advisories/2026-018" target="_blank" rel="noreferrer" className="text-violet-dark hover:text-magenta">
          CERT-EU advisory
        </a>
      </p>
    </aside>
  );
};

export default PhpSecurityAdvisory;
